import React from 'react'
import { propFunc, debounce } from 'util/functions'
import { TextLoader } from 'shared/ui'
import Header from './Header'
import SearchableList from './SearchableList'
import styles from './styles.css'

class SelectTickets extends React.Component {
  componentDidMount() {
    this.updateHeight()
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.mergeableTickets !== this.props.mergeableTickets ||
      nextProps.searchResults !== this.props.searchResults
    ) {
      this.updateHeight()
    }
  }

  updateHeight() {
    const { onHeightChange } = this.props
    if (onHeightChange) onHeightChange(this.mainPane)
  }

  saveRef = node => {
    if (node) this.mainPane = node
  }

  render() {
    const {
      clearSearch,
      direction,
      isDelayed,
      onSearch,
      onSwap,
      queryString,
      ticket,
      hidden,
    } = this.props
    return (
      <div className={styles.MergePage} ref={this.saveRef}>
        <Header ticket={ticket} direction={direction} onSwap={onSwap} />
        {isDelayed && (
          <div className="grui my-12">
            <TextLoader
              text={`Please wait until ${app.t('ticket')} is sent...`}
            />
          </div>
        )}
        {!isDelayed && (
          <SearchableList
            {...this.props}
            onClear={propFunc(clearSearch, ticket.id)}
            onSearch={debounce(onSearch(ticket.id), 500)}
            placeholder="Search..."
            searchTerm={queryString}
            hidden={hidden}
          />
        )}
      </div>
    )
  }
}

export default SelectTickets
